module.exports = __webpack_public_path__ + "img/icon-white-4.1c89be2b.svg";